import axiosClient from "./axiosClient";

export const uploadProductImage = async (imageFile) => {
  const formData = new FormData();

  formData.append("image", imageFile);

  const response = await axiosClient.post("/admin/images/upload", formData);

  return response.data;
};
